export enum ActionType {
  'SET_PAGE' = 'SET_PAGE',
  'SET_SORT' = 'SET_SORT',
  'SET_USER_LOGIN' = 'SET_USER_LOGIN',
  'SET_DISPLAY_NAME' = 'SET_DISPLAY_NAME',
  'RESET' = 'RESET',
}
